import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import ENV from 'umg-ember-backend/config/environment';
import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  hoursvalid: validator('number', {
    allowString: true,
    lte: 1000,
  }),
  maxdownloads: validator('number', {
    allowString: true,
    lte: 1000,
  }),
  format: [validator('belongs-to'), validator('presence', true)],
});

export default class AssetDownloadLinkModel extends Model.extend(Validations) {
  @attr('string') accesskey;
  @attr('number') hoursvalid;
  @attr('number') maxdownloads;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsModified;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @belongsTo('asset', { async: true, inverse: null }) asset;
  @belongsTo('asset-format', { async: true, inverse: null }) format;

  // Getter and setter
  get accessLinks() {
    return {
      de: `${ENV.mediaserviceHost}/de/asset?accesskey=${this.accesskey}`,
      en: `${ENV.mediaserviceHost}/en/asset?accesskey=${this.accesskey}`,
    };
  }
}
